<template>
  <div class="space-y-6">
    <div class="card">
      <div class="card-header">
        Tax Details
      </div>
      <div class="p-6">
        <form @submit.prevent="updateAccount()" class="max-w-xs">
          <fieldset class="form-group">
            <label for="tax_name" class="form-label">
              Tax Name
            </label>
            <input id="tax_name" type="text" class="form-input" v-model="form.tax_name">
          </fieldset>
          <fieldset class="form-group">
            <label for="tax_rate" class="form-label">
              Tax Rate
            </label>
            <div class="relative">
              <input id="tax_rate" type="number" class="form-input" v-model="form.tax_rate">
              <div class="absolute top-0 right-0 flex items-center h-full px-4 text-gray-500 pointer-events-none">
                %
              </div>
            </div>
            <validations :errors="errors" field="tax_rate" />
          </fieldset>
          <fieldset class="form-group">
            <label for="display_prices_excluding_tax" class="flex items-center gap-2 form-label">
              <input id="display_prices_excluding_tax" type="checkbox" class="form-checkbox" v-model="form.display_prices_excluding_tax">
              Display Prices Excluding Tax
            </label>
          </fieldset>
          <fieldset class="form-group">
            <label for="round_display_prices" class="flex items-center gap-2 form-label">
              <input id="round_display_prices" type="checkbox" class="form-checkbox" v-model="form.round_display_prices">
              Round Display Prices
            </label>
          </fieldset>
          <div class="p-4 border rounded form-group bg-gray-50">
            <div class="text-xs font-medium text-gray-500 uppercase">
              Example Display Price for a Product Priced at <currency class="inline m-0" :value="examplePrice" :currency-code="account.currency" :subunits-value="true" />
            </div>
            <div class="flex gap-1 mt-1">
              <currency :value="displayPrice(examplePrice)" :currency-code="account.currency" :subunits-value="true" /> 
              {{ form.display_prices_excluding_tax ? `(excl. ${form.tax_name})` : `(incl. ${form.tax_name})` }}
            </div>
          </div>
          <button type="submit" class="btn btn-primary" v-submitting="submitting">
            Save Details
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SettingsTaxes',

  created () {
    this.form = JSON.parse(JSON.stringify(this.account))
  },

  computed: {
    ...mapGetters(['account']),
  },

  data () {
    return {
      submitting: false,
      examplePrice: 10000,
      errors: [],
      form: {
        tax_name: '',
        tax_rate: 0,
        display_prices_excluding_tax: false,
        round_display_prices: false
      }
    }
  },

  methods: {
    async updateAccount () {
      try {
        this.submitting = true
        await this.$api.patch(`account/${this.$route.params.account}/accounts/${this.form.id}`, this.form)
        this.$store.dispatch('syncUser', this)
        this.$toasted.show('Tax Settings Updated')
      } catch (error) {
        this.$toasted.error(error.response.data.message)
        this.errors = error.response.data.errors ? error.response.data.errors : []
        this.form_errors = error.response.data.form_errors ? error.response.data.form_errors : []
      } finally {
        this.submitting = false
      }
    },

    displayPrice (value) {
      let price = value
      
      if (this.form.display_prices_excluding_tax) {
        price = value / (1 + this.form.tax_rate / 100)
      }

      if (this.form.round_display_prices) {
        price = Math.round(price/100)*100
      }

      return price
    }
  }
}
</script>
